// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Rectangle_wrapper__NQlDP","img":"Rectangle_img__sC-bQ","text":"Rectangle_text__10pEi"};